module.exports = __webpack_public_path__ + "src/assets/individualImages/matchesIcon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/individualImages/matchesIcon.png
// module id = ./src/assets/individualImages/matchesIcon.png
// module chunks = 0